import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function fieldSupportsIconPostfix(field: SchemaField): boolean {
  return !['group', 'section', 'tabs', 'separator'].includes(field.type)
}
